export default __webpack_public_path__ + "d54ff46d2a3f698dda268425ac266fba.png";